import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
var MarkAllRead = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-content-mark-all-read-wireframe", __assign({}, transformedProps), children));
};
var MarkAllResolved = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-content-mark-all-resolved-wireframe", __assign({}, transformedProps), children));
};
VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe.MarkAllRead = MarkAllRead;
VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe.MarkAllResolved = MarkAllResolved;
export default VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe;
